import {
  Alert,
  Backdrop,
  Box,
  Button,
  CircularProgress,
  MenuItem,
  Paper,
  Select,
  Slide,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  TextField,
  Typography,
} from "@mui/material";
import { Dangerous, Download, Edit } from "@mui/icons-material";

import React, { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import Grid from "@mui/material/Grid2";
import api from "../services/api";
import { toast } from "react-toastify";
import { getLocalStorage, userInfo } from "../utils/auth";

import { RemoveRedEye } from "@mui/icons-material";
import * as XLSX from "xlsx";
import { jsPDF } from "jspdf";
import autoTable from "jspdf-autotable";

function AdmitCardList() {
  const { schoolId } = useParams();

  const [studentCategory, setStudentCategory] = useState("Select");
  const [selectExamType, setSelectExamType] = useState("All");
  const [backDropLoading, setBackDropLoading] = useState(false);
  const [dashboardList, setDashboardList] = useState([]);
  const [isPreviewOPen, setIsPreview] = useState(false);
  const [searchType, setSearchType] = useState("");
  const [admitCradCount, setAdmitCardCount] = useState(0);
  const [stateDetails, setStateDetails] = useState({});
  const [admitCardPageNumber, setAdmitCardPageNumber] = useState(0);
  const [schoolCode, setSchoolCode] = useState(schoolId);
  const dashboardData = async () => {
    try {
      setBackDropLoading(true);

      // const response = await api.get(
      //   `compartment/submitted-compart-form?offset=0&limit=500&schoolCode=${
      //     userInfo()?.school_details?.schoolCode
      //   }&registration=${searchType}`
      // );
      const response = await api.get(
        `compartment/submitted-compart-form?limit=300&offset=${
          50 * admitCardPageNumber
        }&registration=${searchType}&schoolCode=${
          schoolCode ? schoolCode : schoolId
        }`
      );

      console.log(response, "fdfdf");
      setDashboardList(response.data?.data?.data);
      setAdmitCardCount(response.data?.data?.total);
      // setDashboardList([{}]);
    } catch (error) {
      toast.error(
        error?.response?.data?.message ??
          "Error fetching data. Please try again."
      );
    } finally {
      setBackDropLoading(false);
    }
  };
  useEffect(() => {
    dashboardData();
  }, [searchType, admitCardPageNumber]);
  const navigate = useNavigate();
  const handleOpen = (item, edit = false) => {
    // setIsPreview(true);
    // setStateDetails(item);
    if (edit) {
      navigate("/edit-details", {
        state: {
          details: {
            ...item,
            ...item?.compartmentFormRequest_data?.other_data,
          },
          edit: true,
        },
      });
    } else {
      if (item?.compartmentFormRequest_data?.other_data) {
        setIsPreview(true);
        setStateDetails(item);
      } else {
        navigate("/personal-details", {
          state: {
            details: item,
          },
        });
      }
    }
  };

  const exportToPDF = () => {
    const doc = new jsPDF();

    // Adding a title
    doc.text("Candidate List", 14, 10);

    autoTable(doc, {
      startY: 20,
      head: [
        [
          "#",
          "BSEB Unique ID",
          "Reg.No",
          "Candidate Details",
          "DOB / Caste / Applied Ctg",
          "Action",
        ],
      ],
      body: dashboardList.map((item, index) => [
        index + 1,
        item.uniqueid || "N/A",
        item.o_reg || "N/A",
        `${item.cname || ""} / ${item.mname || ""} / ${item.fname || ""} / ${
          item.sex || ""
        } / ${item?.rpname === "COMPARTMENT" ? "COMPARTMENT" : "SPECIAL"}`,
        `${item.dob || ""} / ${item.caste || ""} / ${item.rpname || ""}`,
        `${"Applied"}`,
      ]),
    });

    doc.save("Candidate_List.pdf");
  };

  const exportToExcel = () => {
    if (!dashboardList || dashboardList.length === 0) {
      console.error("No data available for export");
      return;
    }

    const headers = [
      [
        "#",
        "BSEB Unique ID",
        "Reg.No",
        "Candidate Details",
        "DOB / Caste / Applied Ctg",
        "Action",
      ],
    ];

    const data = dashboardList.map((item, index) => [
      index + 1,
      item.uniqueid || "N/A",
      item.o_reg || "N/A",
      `${item.cname || ""} / ${item.mname || ""} / ${item.fname || ""} / ${
        item.sex || ""
      } / ${item?.rpname === "COMPARTMENT" ? "COMPARTMENT" : "SPECIAL"}`,
      `${item.dob || ""} / ${item.caste || ""} / ${item.rpname || ""}`,
      `${"Applied"}`,
    ]);

    const worksheet = XLSX.utils.aoa_to_sheet([...headers, ...data]);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Candidates");

    XLSX.writeFile(workbook, "Candidate_List.xlsx");
  };

  const exportToCSV = () => {
    const csvContent = [
      "# , BSEB Unique ID , Reg.No , Candidate Details , DOB / Caste / Applied Ctg, Action",
      ...dashboardList.map((item, index) =>
        [
          index + 1,
          item.uniqueid || "N/A",
          item.o_reg,
          `${item.cname || ""} / ${item.mname || ""} / ${item.fname || ""} / ${
            item.sex || ""
          } / ${item?.rpname === "COMPARTMENT" ? "COMPARTMENT" : "SPECIAL"}`,
          `${item.dob || ""} / ${item.caste || ""} / ${item.rpname || ""}`,
          `${"Applied"}`,
        ].join(",")
      ),
    ].join("\n");
    const blob = new Blob([csvContent], { type: "text/csv" });
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = "table.csv";
    link.click();
  };

  const handlePrint = () => {
    window.print();
  };

  const getStudentsData = () => {
    if (selectExamType == "All" && studentCategory == "Select") {
      return dashboardList;
    }
    let filteredData = dashboardList;

    if (selectExamType === "Compartmental") {
      filteredData = filteredData.filter(
        (item) => item?.exam_type === "COMPARTMENTAL"
      );
      return filteredData;
    }
    if (selectExamType === "Special") {
      filteredData = filteredData.filter(
        (item) => item?.exam_type !== "COMPARTMENTAL"
      );
      return filteredData;
    }

    if (studentCategory === "Single Subject (English)") {
      filteredData = filteredData.filter(
        (item) => item?.rpname === "SINGLE SUBJECT"
      );
      return filteredData;
    }

    if (studentCategory === "B") {
      filteredData = filteredData.filter(
        (item) => item?.rpname === "BETTERMENT"
      );
      return filteredData;
    }
    if (studentCategory === "C") {
      filteredData = filteredData.filter(
        (item) => item?.exam_type === "COMPARTMENTAL"
      );
      return filteredData;
    }
    if (studentCategory === "R") {
      filteredData = filteredData.filter((item) => item?.rpname == "REGULAR");
      return filteredData;
    }
    // if (studentCategory === "Select") {
    //   filteredData = filteredData.filter(
    //     (item) => item?.exam_type !== "COMPARTMENTAL"
    //   );
    //   return filteredData;
    // }

    if (studentCategory === "E") {
      filteredData = filteredData.filter((item) => item?.rpname === "EX");
      return filteredData;
    }
  };

  useEffect(() => {
    if (selectExamType === "Compartmental") {
      setStudentCategory("C");
    } else {
      setStudentCategory("Select");
    }
  }, [selectExamType]);

  const getSingleSUbjectsList = (student) => {
    if (
      student?.res1 !== "F" &&
      student?.res2 !== "F" &&
      student?.res3 !== "F" &&
      student?.res4 !== "F" &&
      student?.res5 !== "F" &&
      student?.res6 !== "F" &&
      student?.res7 === "F" &&
      student?.res8 !== "F"
    ) {
      return true;
    } else return false;
    // let reqData = resFields.filter((item) => {
    //   // Check if res7 is "F" and all other resX fields are not "F"
    //   return resFields.every((field, index) =>
    //     field === "res7" ? item[field] === "F" : item[field] !== "F"
    //   );
    // });
  };

  const handleChangePage = (event, newPage) => {
    setAdmitCardPageNumber(newPage);
  };

  const [selectedCheckbox, setSelectedCheckbox] = useState([]);
  const handleCheckBox = (id) => {
    setSelectedCheckbox((prev) =>
      prev.includes(id) ? prev.filter((rowId) => rowId !== id) : [...prev, id]
    );
  };
  const [isAllSelected, setIsAllSelected] = useState(false);

  const handleViewList = () => {
    const selectedStudents = getStudentsData().filter(
      (item) =>
        (selectedCheckbox.includes(item?.pk_id) || isAllSelected) &&
        item?.status !== 0
    );
    console.log(selectedStudents, "selectedStudents");
    navigate(`/admit-card/1`, {
      state: {
        details: { selectedStudents },
      },
    });
  };

  const handleUpdateStatus = async (id, status) => {
    setBackDropLoading(true);
    try {
      await api.patch("compartment/update-admit-card-status", {
        id: id,
      });
      toast.success("Status Updated Successfully");
      dashboardData();
    } catch (error) {
      toast.error(
        error?.response?.data?.message ?? "Error Updating. Please try again."
      );
    } finally {
      setBackDropLoading(false);
    }
  };
  return (
    <>
      <Box sx={{ textAlign: "center", width: "95%", justifySelf: "center" }}>
        <Typography
          variant="subtitle1"
          sx={{ textAlign: "center", color: "blue", fontWeight: "bold" }}
          className="card-title"
        >
          School Code: {schoolId}
          {/* {` `} {`:: `}
          School Name: {userInfo()?.school_details?.name} */}
        </Typography>
        <Grid
          container
          spacing={1}
          sx={{ mt: 3, alignItems: "start" }}
          style={{ marginBottom: "12px" }}
          className="card-title"
        >
          <Grid item size={{ xs: 12, md: 5, xl: 5, sm: 4 }}>
            <Typography variant="body1" className="card-title">
              Select Exam Type:
            </Typography>
            <Select
              value={selectExamType}
              onChange={(e) => {
                setSelectExamType(e.target.value);
              }}
              fullWidth
              defaultValue="Special"
              className="card-title"
            >
              <MenuItem value="All">All</MenuItem>
              <MenuItem value="Compartmental">Compartmental</MenuItem>
              {/* <MenuItem value="Ex-Private">Ex-Private</MenuItem> */}
              <MenuItem value="Special">Special</MenuItem>
            </Select>
          </Grid>
          <Grid item size={{ xs: 12, md: 5, xl: 5, sm: 4 }}>
            <Typography variant="body1" className="card-title">
              Select Student Category
            </Typography>
            <Select
              value={studentCategory}
              onChange={(e) => {
                setStudentCategory(e.target.value);
              }}
              fullWidth
              defaultValue="Special"
              className="card-title"
            >
              <MenuItem value="Select">Select</MenuItem>

              {selectExamType !== "Compartmental" && (
                <MenuItem value="R"> Reg/Pvt</MenuItem>
              )}
              {/* <MenuItem value="Ex-Private">Ex-Private</MenuItem> */}
              {selectExamType !== "Special" && (
                <MenuItem value="C">Compartment</MenuItem>
              )}
              {selectExamType !== "Compartmental" && (
                <MenuItem value="E">Ex-Student</MenuItem>
              )}
              {selectExamType !== "Compartmental" && (
                <MenuItem value="B">Betterment</MenuItem>
              )}
              {selectExamType !== "Compartmental" && (
                <MenuItem value="Single Subject (English)">
                  Single Subject (English)
                </MenuItem>
              )}
              {selectExamType !== "Compartmental" && (
                <MenuItem value="Opt. Prac">Opt. Prac</MenuItem>
              )}
            </Select>
          </Grid>
        </Grid>
        <Box sx={{ mt: 2, display: "flex", gap: 1 }}>
          <Button variant="contained" onClick={handlePrint}>
            Print
          </Button>
          {/* <Button variant="contained">Copy</Button> */}
          <Button variant="contained" onClick={exportToCSV}>
            CSV
          </Button>
          <Button variant="contained" onClick={exportToExcel}>
            Excel
          </Button>
          <Button variant="contained" onClick={exportToPDF}>
            PDF
          </Button>

          {(selectedCheckbox.length || isAllSelected) &&
          // getLocalStorage("isMaster") ? (
          true ? (
            <Button
              onClick={handleViewList}
              style={{
                marginLeft: "auto",
              }}
              variant="contained"
            >
              View Selected Students
            </Button>
          ) : null}
        </Box>

        <Paper containr sx={{ width: "100%", marginTop: "5px" }}>
          <Box
            sx={{
              width: "100px",
              marginRight: "auto",
            }}
          >
            <Button
              variant="outlined"
              color="primary"
              onClick={() => {
                navigate("/dashboard");
              }}
              style={{
                // width: "20px",
                marginRight: "auto",
                // margin: "25px",
                // marginTop: "2px",
                // marginBottom: "0px",
              }}
            >
              Back
            </Button>
          </Box>
          <Box
            sx={{
              width: "700px",
              marginLeft: "auto",
            }}
          >
            <TextField
              // fullWidth
              variant="outlined"
              size="small"
              value={schoolCode}
              style={{
                width: "250px",
              }}
              label="School Code"
              onChange={(e) => setSchoolCode(e?.target?.value)}
              inputProps={{ inputMode: "numeric", pattern: "[0-9]*" }} // Ensures only numeric input
              onInput={(e) => {
                e.target.value = e.target.value.replace(/\D/g, ""); // Removes non-numeric characters
              }}
            />
            <Button
              variant="contained"
              color="primary"
              onClick={() => {
                dashboardData();
              }}
              style={{
                margin: "25px",
                marginTop: "2px",
                marginBottom: "0px",
              }}
              disabled={
                schoolCode?.length === 5 || schoolCode?.length === 0
                  ? false
                  : true
              }
            >
              Search
            </Button>
            <TextField
              // fullWidth
              variant="outlined"
              size="small"
              value={searchType}
              style={{
                width: "250px",
              }}
              label="Search By Reg.No"
              onChange={(e) => setSearchType(e?.target?.value)}
            />
          </Box>

          <TableContainer
            // sx={{
            //   maxHeight: "65vh",
            //   overflow: "auto",
            //   mt: 2,
            //   width: "99.90%",
            //   border: "1px solid black",
            //   borderRight: "none",
            // }}

            sx={{
              // maxHeight: "65vh",
              // mt: 4,
              // border: "1px solid black",

              overflowY: "scroll", // Ensure scrollbar is always visible
              scrollbarWidth: "thin", // Firefox support
              "&::-webkit-scrollbar": {
                width: "8px", // Chrome & Safari
              },
              "&::-webkit-scrollbar-thumb": {
                background: "#888", // Color of scrollbar
                borderRadius: "4px",
              },
              "&::-webkit-scrollbar-thumb:hover": {
                background: "#555",
              },

              maxHeight: "65vh",
              overflow: "auto",
              mt: 2,
              width: "99.90%",
              border: "1px solid black",
              borderRight: "none",
            }}
            component={Paper}
          >
            <Table stickyHeader>
              <TableHead xsx={{ borderRight: "2px solid #000" }}>
                <TableRow>
                  <TableCell
                    className="card-title"
                    sx={{
                      borderRight: "1px solid #000",
                      borderBottom: "1px solid #000",
                    }}
                  >
                    #
                  </TableCell>
                  <TableCell
                    className="card-title"
                    style={{ minWidth: "110px" }}
                    sx={{
                      borderRight: "1px solid #000",
                      borderBottom: "1px solid #000",
                    }}
                  >
                    BSEB Unique ID
                  </TableCell>
                  <TableCell
                    className="card-title"
                    style={{ minWidth: "60px" }}
                    sx={{
                      borderRight: "1px solid #000",
                      borderBottom: "1px solid #000",
                    }}
                  >
                    Reg.No
                  </TableCell>
                  <TableCell
                    className="card-title"
                    style={{ minWidth: "380px" }}
                    sx={{
                      borderRight: "1px solid #000",
                      borderBottom: "1px solid #000",
                    }}
                  >
                    Candidate’s Name/Mother’s Name/Father’s Name / sex / Exam
                    Type
                  </TableCell>
                  <TableCell
                    className="card-title"
                    style={{ minWidth: "210px" }}
                    sx={{
                      borderRight: "1px solid #000",
                      borderBottom: "1px solid #000",
                    }}
                  >
                    D-O-B / Caste / Applied Ctg
                  </TableCell>
                  <TableCell
                    className="card-title"
                    style={{ minWidth: "210px" }}
                    sx={{
                      borderRight: "1px solid #000",
                      borderBottom: "1px solid #000",
                    }}
                  >
                    Remarks
                  </TableCell>
                  {/* <TableCell
                      className="card-title"
                      sx={{
                        borderRight: "1px solid #000",
                        borderBottom: "1px solid #000",
                        display: "flex",
                        zIndex: "1000",
                      }}
                    >
                      <input
                        type="checkbox"
                        onChange={(e) => setIsAllSelected(e.target.checked)}
                        checked={isAllSelected}
                      />
                      <Typography>Action</Typography>
                    </TableCell> */}
                  <TableCell
                    className="card-title"
                    sx={{
                      borderRight: "1px solid #000",
                      borderBottom: "1px solid #000",
                      position: "sticky",
                      top: 0,
                      backgroundColor: "#fff", // Important: to avoid overlap transparency
                      zIndex: 100,
                    }}
                  >
                    <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                      <input
                        type="checkbox"
                        onChange={(e) => setIsAllSelected(e.target.checked)}
                        checked={isAllSelected}
                      />
                      <Typography>Action</Typography>
                    </Box>
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {/* Example Row */}
                {/* <TableRow>
                  <TableCell className="card-title">1</TableCell>
                  <TableCell className="card-title">123456</TableCell>
                  <TableCell className="card-title">78910</TableCell>
                  <TableCell className="card-title">John Doe / Jane Doe / Richard Doe / Male / Regular</TableCell>
                  <TableCell className="card-title">12-05-2005 / General / Reg</TableCell>
                 
                  <TableCell>
                   <Button  variant="contained"
                    sx={{ mt: 2, backgroundColor: "#007bff", color: "white" }} onClick={handleOpen}>Apply</Button>
                  </TableCell>
                </TableRow> */}

                {/* {dashboardList?.map((item, index) => { */}
                {getStudentsData()?.map((item, index) => {
                  return (
                    <TableRow className="tableBody_styles">
                      <TableCell className="card-title">{index + 1}</TableCell>
                      <TableCell className="card-title">
                        {item?.uniqueid?.toString()?.includes(".0")
                          ? item?.uniqueid?.split(".0")[0]
                          : item?.uniqueid}
                      </TableCell>
                      <TableCell className="card-title">
                        {item?.o_reg}
                      </TableCell>
                      <TableCell className="card-title">
                        {/* {item?.student_name} / {item?.mnm} /{" "}
                                    {item?.fnm} /{" "} */}
                        {item?.cname ? `${item?.cname}` : ""}
                        {item?.mname
                          ? `${item?.cname ? "/" : ""} ${item?.mname} `
                          : ""}
                        {item?.fname
                          ? `${item?.mname ? "/" : ""} ${item?.fname} `
                          : ""}
                        {item?.sex
                          ? `${item?.fname ? "/" : ""} ${item?.sex} `
                          : ""}
                        {/* {item?.exam_type ? `${item?.sex ? "/" : ""}` : ""} */}
                        {item?.exam_type
                          ? `${item?.sex ? "/" : ""}  ${item?.exam_type} `
                          : item?.exam_type}
                        {/* {item?.fr
                            } */}
                      </TableCell>
                      <TableCell className="card-title">
                        {/* {item?.dob} / {item?.caste} / {item?.applycat} */}
                        {item?.dob ? `${item?.dob}` : ""}
                        {item?.caste
                          ? ` ${item?.dob ? "/" : ""} ${item?.caste} `
                          : ""}
                        {item?.rpname
                          ? `${item?.caste ? "/" : ""}  ${item?.rpname} `
                          : ""}
                      </TableCell>
                      <TableCell className="card-title">
                        {/* {item?.dob} / {item?.caste} / {item?.applycat} */}
                        {item?.remark && item?.remark !== "NaN"
                          ? item?.remark
                          : "_"}
                      </TableCell>
                      {/* {getLocalStorage("isMaster") ? ( */}
                      {true ? (
                        <TableCell sx={{ borderRight: "3px solid #000" }}>
                          <Box
                            sx={{
                              display: "flex",
                              alignItems: "center",
                              gap: 1, // or use mx, spacing, etc
                              flexWrap: "nowrap", // force same line
                            }}
                          >
                            <input
                              onClick={() => {
                                handleCheckBox(item?.pk_id);
                              }}
                              checked={
                                item?.status == 0
                                  ? false
                                  : selectedCheckbox?.includes(item?.pk_id) ||
                                    isAllSelected
                              }
                              type="checkbox"
                              disabled={item?.status == 0 ? true : false}
                            />
                            <Button
                              variant="contained"
                              sx={{
                                mt: 0, // reset any offset
                                backgroundColor: "#007bff",
                                color: "white",
                                whiteSpace: "nowrap", // avoids button text wrapping
                                minWidth: "auto", // keeps it compact if needed
                              }}
                              startIcon={<Download />}
                              onClick={() =>
                                navigate(`/admit-card/${item?.id}`, {
                                  state: {
                                    details: { selectedStudents: [item] },
                                  },
                                })
                              }
                              disabled={item?.status == 0 ? true : false}
                            >
                              Admit Card
                            </Button>
                            <Button
                              variant="contained"
                              sx={{
                                mt: 0, // reset any offset
                                backgroundColor:
                                  item?.status == 0 ? "green" : "red",
                                color: "white",
                                whiteSpace: "nowrap", // avoids button text wrapping
                                minWidth: "auto", // keeps it compact if needed
                              }}
                              startIcon={<Dangerous />}
                              onClick={() =>
                                handleUpdateStatus(item?.pk_id, item?.status)
                              }
                              //   disabled={item?.status == 0 ? true : false}
                            >
                              {item?.status == 0 ? "Enable" : "Disable"}
                            </Button>
                          </Box>
                        </TableCell>
                      ) : (
                        <TableCell
                          xs={{ borderRight: "3px solid #000" }}
                        ></TableCell>
                      )}
                    </TableRow>
                  );
                })}

                {/* <TableRow>
                  <TableCell>2</TableCell>
                  <TableCell>123456</TableCell>
                  <TableCell>78910</TableCell>
                  <TableCell>John Doe / Jane Doe / Richard Doe / Male / Regular</TableCell>
                  <TableCell>12-05-2005 / General / Reg</TableCell>
                  
                  <TableCell>
                  <Button  variant="contained"
                    sx={{ mt: 2, backgroundColor: "#007bff", color: "white" }}>Apply</Button>
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>3</TableCell>
                  <TableCell>123456</TableCell>
                  <TableCell>78910</TableCell>
                  <TableCell>John Doe / Jane Doe / Richard Doe / Male / Regular</TableCell>
                  <TableCell>12-05-2005 / General / Reg</TableCell>
                 
                 
                  <TableCell>
                  <Button  variant="contained"
                    sx={{ mt: 2, backgroundColor: "#007bff", color: "white" }}>Apply</Button>
                  </TableCell>
                </TableRow> */}
              </TableBody>
            </Table>
          </TableContainer>
          <TablePagination
            rowsPerPageOptions={[]}
            component="div"
            count={admitCradCount}
            rowsPerPage={50}
            page={admitCardPageNumber}
            onPageChange={(event, newPage) =>
              handleChangePage(event, newPage, "agency")
            }
          />
        </Paper>
      </Box>

      {/* <PreviewModal
          setIsModalOpen={setIsPreview}
          UserDetails={{}}
          // stateDetails={{}}
          preDetails={stateDetails}
          view={true}
          isModalOpen={isPreviewOPen}
        /> */}
      <Backdrop open={backDropLoading} style={{ zIndex: 1300, color: "#fff" }}>
        <CircularProgress color="inherit" />
      </Backdrop>
    </>
  );
}

export default AdmitCardList;
